import { render } from "./AlertsPage.vue?vue&type=template&id=59660789&ts=true"
import script from "./AlertsPage.vue?vue&type=script&lang=ts"
export * from "./AlertsPage.vue?vue&type=script&lang=ts"

import "./AlertsPage.vue?vue&type=style&index=0&id=59660789&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__